import {
  ArrowLeftOutlined,
  CheckCircleFilled,
  CheckOutlined,
  FireFilled,
} from "@ant-design/icons";
import { Button, Col, Row, Tag, Typography } from "antd";
import { useEffect, useState } from "react";
import BrandButton from "../../../components/v2/Buttons/BrandButton";
import {
  ACTIONTYPES,
  useStore,
  useStoreDispatch,
} from "../../../context/CreateStoreContext";
import style from "./SubsPlan.module.css";
import { pricing2025 as plans } from "../../../constants/pricingTier";
import useComponentSize from "../../../hooks/useComponentSize";

const { Title, Paragraph } = Typography;
const plan1items = [
  "Bevz iPad & Software",
  "Menu management & optimization",
  "Product Catalog",
  "Delivery Services",
];
const plan2items = ["Bevz Reach", "Shop.Bevz", "Bevz Reporting+"];

export default function SubsPlan({ proceed, back }) {
  const componentSize = useComponentSize();
  const dispatch = useStoreDispatch();
  const { plan, integrator } = useStore();
  const [selectedPlan, setSelectedPlan] = useState(plans.BASIC.value);

  const handleSubmit = () => {
    dispatch({ type: ACTIONTYPES.PLAN, data: selectedPlan });
    proceed();
  };

  const handleClickPlan = (selected) => {
    setSelectedPlan(selected);
  };

  useEffect(() => {
    const defaultPlan = plan
      ? plan
      : integrator?.id
      ? plans.BASIC.value
      : plans.GROWTH.value;
    setSelectedPlan(defaultPlan);

    dispatch({
      type: ACTIONTYPES.PLAN,
      data: defaultPlan,
    });
  }, []);

  return (
    <Row className="BevzForm">
      <Col
        xs={{ span: 22, offset: 1 }}
        lg={{ span: 20, offset: 2 }}
        xl={{ span: 15, offset: 2 }}
      >
        <Title
          level={componentSize === "default" ? 4 : 2}
          className="BevzFormHeader"
        >
          Subscription Plan
        </Title>
        <Paragraph className="BevzFormSubHeader">
          Choose your subscription plan that suites your store.
        </Paragraph>

        <div className={style.plans}>
          <div>
            <div
              className={
                selectedPlan === plans.BASIC.value
                  ? `${style.plans_container} ${style.selected}`
                  : style.plans_container
              }
              onClick={handleClickPlan.bind(this, plans.BASIC.value)}
            >
              <div className={style.section1}>
                <div>
                  <h2>Basic Plan</h2>
                  <p className={style.subTitle}>
                    The basic essentials for your store.
                  </p>
                </div>
                {integrator?.id ? null : (
                  <div>
                    <p className={style.price}>
                      $99<span>/month</span>
                    </p>
                  </div>
                )}
              </div>
              <div className={style.section2}>
                {plan1items.map((item, i) => (
                  <p key={i}>
                    <CheckOutlined style={{ color: "#007AFF" }} /> {item}
                  </p>
                ))}
              </div>
            </div>
            {selectedPlan === plans.BASIC.value ? <CheckIcon /> : null}
          </div>

          {integrator?.id ? null : (
            <div>
              <div
                className={
                  selectedPlan === plans.GROWTH.value
                    ? `${style.plans_container} ${style.selected}`
                    : style.plans_container
                }
                onClick={handleClickPlan.bind(this, plans.GROWTH.value)}
              >
                <div className={style.section1}>
                  <div>
                    <h2>
                      Growth Plan{" "}
                      {componentSize === "default" ? (
                        <Tag
                          icon={<FireFilled />}
                          bordered={false}
                          color="gold"
                          style={{ borderRadius: "20px" }}
                        >
                          Popular
                        </Tag>
                      ) : null}
                    </h2>
                    <p className={style.subTitle}>
                      Enhanced tools and resources, perfect for maximizing your
                      store's potential.
                    </p>
                  </div>
                  <div>
                    <p className={style.price}>
                      $149<span>/month</span>
                    </p>
                  </div>
                </div>
                <div className={style.section2}>
                  <p className={style.subHeading}>
                    Everything in Basic Plan, plus:
                  </p>
                  {plan2items.map((item, i) => (
                    <p key={i}>
                      <CheckOutlined style={{ color: "#007AFF" }} /> {item}
                    </p>
                  ))}
                </div>
              </div>
              {selectedPlan === plans.GROWTH.value ? <CheckIcon /> : null}
            </div>
          )}
        </div>

        <Row
          align="middle"
          justify="space-between"
          className="BevzFormButtonSection"
        >
          <Col>
            <Button
              type="default"
              shape="round"
              icon={<ArrowLeftOutlined />}
              onClick={back}
              size="large"
            >
              Back
            </Button>
          </Col>
          <Col>
            <BrandButton
              type="solidyellow"
              htmlType="submit"
              onSubmit={handleSubmit}
              size="large"
            >
              {componentSize === "default"
                ? "Proceed"
                : "Proceed to Review Summary"}
            </BrandButton>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

const CheckIcon = () => (
  <div className={style.CheckIcon}>
    <CheckCircleFilled className={style.icon} />
  </div>
);
